import { styled } from 'styled-components';
import { StyledInput } from '../common';
export const ReStyledInput = styled(StyledInput) `
  border: 0;
  border-radius: 0;
  width: 100%;

  &:focus-visible,
  &:focus {
    box-shadow: none;
  }

  &:hover {
    border: 0;
  }
`;
